const AUTHENTICATE = 'AUTHENTICATE';
const SET_AUTHENTICATE_DATA = 'SET_AUTHENTICATE_DATA';
const UPDATE_LOGIN_STATUS = 'UPDATE_LOGIN_STATUS';
const LOGOUT = 'LOGOUT';
const REMOVE_SESSION_DATA = 'REMOVE_SESSION_DATA';


const authenticate = data => {
    return {
        type: AUTHENTICATE,
        data
    };
}

const updateLoginStatus = data => {
    return {
        type: UPDATE_LOGIN_STATUS,
        data
    }
}

const setAuthenticateData = data => {
    return {
        type: SET_AUTHENTICATE_DATA,
        data
    }
}

const logout = () => {
    return {
        type: LOGOUT,
    }
}

const removeSessionData = () => {
    return {
        type: REMOVE_SESSION_DATA,
    }
}

export default {
    types: {
        AUTHENTICATE,
        SET_AUTHENTICATE_DATA,
        UPDATE_LOGIN_STATUS,
        LOGOUT,
        REMOVE_SESSION_DATA
    },
    actions: {
        authenticate,
        setAuthenticateData,
        updateLoginStatus,
        logout,
        removeSessionData
    }
}